/**
 * Plugin to enable the Vuex ORM
 */
import VuexORM from '@vuex-orm/core';
import database from '@/orm/database';

export default VuexORM.install(database);
